// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file auth/auth_respones.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { DeviceError_DeviceIsBlocked } from '../device/device_errors_pb';
import { file_device_device_errors } from '../device/device_errors_pb';
import type { Device_Status } from '../device/device_model_pb';
import { file_device_device_model } from '../device/device_model_pb';
import type { DeviceKeyPackagesCount } from '../encryption/encryption_model_pb';
import { file_encryption_encryption_model } from '../encryption/encryption_model_pb';
import type { User } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';
import type { ClientConfig } from './auth_model_pb';
import { file_auth_auth_model } from './auth_model_pb';

/**
 * Describes the file auth/auth_respones.proto.
 */
export const file_auth_auth_respones: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_auth_auth_model,
      file_user_user_model,
      file_device_device_errors,
      file_device_device_model,
      file_encryption_encryption_model,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.LoginResponse
 */
export type LoginResponse = Message<'com.gem.bff.contract.LoginResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.LoginResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.LoginSuccess success = 1;
         */
        value: LoginSuccess;
        case: 'success';
      }
    | {
        /**
         * TODO need to add errors
         *
         * @generated from field: com.gem.bff.contract.DeviceError.DeviceIsBlocked deviceIsBlocked = 2;
         */
        value: DeviceError_DeviceIsBlocked;
        case: 'deviceIsBlocked';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 0);

/**
 * @generated from message com.gem.bff.contract.LoginSuccess
 */
export type LoginSuccess = Message<'com.gem.bff.contract.LoginSuccess'> & {
  /**
   * @generated from field: string accessToken = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refreshToken = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: com.gem.bff.contract.ClientConfig clientConfig = 3;
   */
  clientConfig?: ClientConfig;

  /**
   * @generated from field: com.gem.bff.contract.User user = 4;
   */
  user?: User;

  /**
   * @generated from field: repeated com.gem.bff.contract.DeviceKeyPackagesCount deviceKeyPackagesCount = 5;
   */
  deviceKeyPackagesCount: DeviceKeyPackagesCount[];

  /**
   * @generated from field: optional com.gem.bff.contract.Device.Status deviceStatus = 6;
   */
  deviceStatus?: Device_Status;
};

/**
 * Describes the message com.gem.bff.contract.LoginSuccess.
 * Use `create(LoginSuccessSchema)` to create a new message.
 */
export const LoginSuccessSchema: GenMessage<LoginSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 1);

/**
 * @generated from message com.gem.bff.contract.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<'com.gem.bff.contract.RefreshTokenResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.RefreshTokenResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.RefreshTokenSuccess success = 1;
         */
        value: RefreshTokenSuccess;
        case: 'success';
      }
    | {
        /**
         * TODO need to add errors
         *
         * @generated from field: com.gem.bff.contract.DeviceError.DeviceIsBlocked deviceIsBlocked = 2;
         */
        value: DeviceError_DeviceIsBlocked;
        case: 'deviceIsBlocked';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 2);

/**
 * @generated from message com.gem.bff.contract.RefreshTokenSuccess
 */
export type RefreshTokenSuccess = Message<'com.gem.bff.contract.RefreshTokenSuccess'> & {
  /**
   * @generated from field: string accessToken = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refreshToken = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: com.gem.bff.contract.ClientConfig clientConfig = 3;
   */
  clientConfig?: ClientConfig;

  /**
   * @generated from field: com.gem.bff.contract.User user = 4;
   */
  user?: User;

  /**
   * @generated from field: repeated com.gem.bff.contract.DeviceKeyPackagesCount deviceKeyPackagesCount = 5;
   */
  deviceKeyPackagesCount: DeviceKeyPackagesCount[];

  /**
   * @generated from field: optional com.gem.bff.contract.Device.Status deviceStatus = 6;
   */
  deviceStatus?: Device_Status;
};

/**
 * Describes the message com.gem.bff.contract.RefreshTokenSuccess.
 * Use `create(RefreshTokenSuccessSchema)` to create a new message.
 */
export const RefreshTokenSuccessSchema: GenMessage<RefreshTokenSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 3);

/**
 * @generated from message com.gem.bff.contract.LogoutResponse
 */
export type LogoutResponse = Message<'com.gem.bff.contract.LogoutResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.LogoutResponse.type
   */
  type:
    | {
        /**
         * TODO need to add errors
         *
         * @generated from field: com.gem.bff.contract.LogoutSuccess success = 1;
         */
        value: LogoutSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 4);

/**
 * @generated from message com.gem.bff.contract.LogoutSuccess
 */
export type LogoutSuccess = Message<'com.gem.bff.contract.LogoutSuccess'> & {};

/**
 * Describes the message com.gem.bff.contract.LogoutSuccess.
 * Use `create(LogoutSuccessSchema)` to create a new message.
 */
export const LogoutSuccessSchema: GenMessage<LogoutSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 5);

/**
 * @generated from message com.gem.bff.contract.GetAuthUrlResponse
 */
export type GetAuthUrlResponse = Message<'com.gem.bff.contract.GetAuthUrlResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetAuthUrlResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.AuthUrlSuccess success = 1;
         */
        value: AuthUrlSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetAuthUrlResponse.
 * Use `create(GetAuthUrlResponseSchema)` to create a new message.
 */
export const GetAuthUrlResponseSchema: GenMessage<GetAuthUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 6);

/**
 * @generated from message com.gem.bff.contract.AuthUrlSuccess
 */
export type AuthUrlSuccess = Message<'com.gem.bff.contract.AuthUrlSuccess'> & {
  /**
   * @generated from field: string authUrl = 1;
   */
  authUrl: string;

  /**
   * @generated from field: string support_email = 2;
   */
  supportEmail: string;
};

/**
 * Describes the message com.gem.bff.contract.AuthUrlSuccess.
 * Use `create(AuthUrlSuccessSchema)` to create a new message.
 */
export const AuthUrlSuccessSchema: GenMessage<AuthUrlSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 7);

/**
 * @generated from message com.gem.bff.contract.BffGetSupportEmailResponse
 */
export type BffGetSupportEmailResponse =
  Message<'com.gem.bff.contract.BffGetSupportEmailResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.BffGetSupportEmailResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SupportEmailSuccess success = 1;
           */
          value: SupportEmailSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.BffGetSupportEmailResponse.
 * Use `create(BffGetSupportEmailResponseSchema)` to create a new message.
 */
export const BffGetSupportEmailResponseSchema: GenMessage<BffGetSupportEmailResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 8);

/**
 * @generated from message com.gem.bff.contract.SupportEmailSuccess
 */
export type SupportEmailSuccess = Message<'com.gem.bff.contract.SupportEmailSuccess'> & {
  /**
   * @generated from field: string support_email = 1;
   */
  supportEmail: string;
};

/**
 * Describes the message com.gem.bff.contract.SupportEmailSuccess.
 * Use `create(SupportEmailSuccessSchema)` to create a new message.
 */
export const SupportEmailSuccessSchema: GenMessage<SupportEmailSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 9);

/**
 * @generated from message com.gem.bff.contract.GetRegistrationUrlResponse
 */
export type GetRegistrationUrlResponse =
  Message<'com.gem.bff.contract.GetRegistrationUrlResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetRegistrationUrlResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.RegistrationUrlSuccess success = 1;
           */
          value: RegistrationUrlSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetRegistrationUrlResponse.
 * Use `create(GetRegistrationUrlResponseSchema)` to create a new message.
 */
export const GetRegistrationUrlResponseSchema: GenMessage<GetRegistrationUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 10);

/**
 * @generated from message com.gem.bff.contract.RegistrationUrlSuccess
 */
export type RegistrationUrlSuccess = Message<'com.gem.bff.contract.RegistrationUrlSuccess'> & {
  /**
   * @generated from field: string registrationUrl = 1;
   */
  registrationUrl: string;

  /**
   * @generated from field: string adminUiUrl = 2;
   */
  adminUiUrl: string;
};

/**
 * Describes the message com.gem.bff.contract.RegistrationUrlSuccess.
 * Use `create(RegistrationUrlSuccessSchema)` to create a new message.
 */
export const RegistrationUrlSuccessSchema: GenMessage<RegistrationUrlSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 11);
